import {AppConfig} from '../AppConfig'

// Специально анонимная функция.
// Шифрует строку с помощью публичного ключа.
export default async function (url: string): Promise<string> {
    const a: CryptoKey = await window['c' + 'ry' + 'pto' as 'crypto']['s' + 'ubt' + 'le' as 'subtle']['i' + 'mp' + 'ortK' + 'ey' as 'importKey'](
        // Формат публичного ключа.
        ('sp' + 'ki' as 'spki'),
        // Публичный ключ.
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        AppConfig['l' + 'ara' + 'velE' + 'cho' as 'laravelEcho']['t' + 'ok' + 'en' as 'token'],
        {
            // eslint-disable-next-line
            name: 'R' + 'SA-' + 'OA' + 'EP' as 'RSA-OAEP',
            hash: 'S' + 'HA' + '-2' + '5' + '6' as 'SHA-256',
        },
        true,
        ['e' + 'nc' + 'ry' + 'pt' as 'encrypt']
    )

    // 2. Encode the string text to bytes
    const e: TextEncoder = new window['T' + 'extE' + 'nco' + 'der' as 'TextEncoder']()
    const b: Uint8Array<ArrayBuffer> = e['e' + 'nc' + 'od' + 'e' as 'encode'](url)

    // 3. Encrypt the data buffer
    const eb: ArrayBuffer = await window['c' + 'ry' + 'pto' as 'crypto']['s' + 'ubt' + 'le' as 'subtle']['e' + 'nc' + 'ry' + 'pt' as 'encrypt'](
        // eslint-disable-next-line
        {name: 'R' + 'SA-' + 'OA' + 'EP' as 'RSA-OAEP'},
        a,
        b
    )

    // 4. Convert the output ArrayBuffer back to Base64 for transport/storage
    const bts: Uint8Array<ArrayBuffer> = new window['U' + 'in' + 't8' + 'Ar' + 'ray' as 'Uint8Array'](eb)
    let bin: string = ''
    for (let i: number = 0; i < bts['b' + 'yt' + 'eLe' + 'ng' + 'th' as 'byteLength']; i++) {
        bin += String['f' + 'ro' + 'mCh' + 'arCo' + 'de' as 'fromCharCode'](bts[i])
    }
    return window['b' + 't' + 'oa' as 'btoa'](bin)
}
